export default "__VITE_ASSET__DLDbImnr__"